import moment from 'moment'
import React from 'react'

const CustomTooltip = ({ active, payload }) => {
  if (!payload || payload.length === 0) {
    return null
  }

  const getLabel = (tooltip) => {
    if (tooltip.payload.date) {
      return moment(tooltip.payload.date).format('DD/MM/YYYY')
    }
    return tooltip.payload.name
  }

  if (active) {
    return (
      <div className="custom-tooltip">
        <span className="label">{`${getLabel(payload[0])} : ${payload[0].value}`}</span>
      </div>
    )
  }

  return null
}

export default CustomTooltip
